import { createDownstreamStatusUpdateNotification } from './createDownstreamStatusUpdateToAvNotification';
import {
  buildNotificationCandidates,
  getNeedOptionsByField,
  getStatusOptionsByField,
} from './downstreamStatusUpdateToAvHelper';
import {
  Option,
  ProcessDownstreamStatusUpdateToAvNotificationsParams,
} from './downstreamStatusUpdateToAvTypes';

// Orchestrates downstream update notification creation for the current commit batch.
export async function processDownstreamStatusUpdateToAvNotifications({
  editedRow,
  editedRowOriginal,
  allAccessibleColumns,
  screenGridId,
  createdBy,
  configSchema,
}: ProcessDownstreamStatusUpdateToAvNotificationsParams): Promise<string | null> {
  if (!editedRow.length) {
    return null;
  }

  const optionsByField = getStatusOptionsByField(allAccessibleColumns);
  const optionsByNeedField = getNeedOptionsByField(allAccessibleColumns);
  const valueOptionsProfitCenter = (allAccessibleColumns.find(
    (col) => col.attrInternalName === 'pf_lc',
  )?.valueOptions ?? []) as Option[];
  const valueOptionsWerk = (allAccessibleColumns.find(
    (col) => col.attrInternalName === 'werk',
  )?.valueOptions ?? []) as Option[];

  const candidates = buildNotificationCandidates({
    editedRow,
    editedRowOriginal,
    optionsByField,
    optionsByNeedField,
    valueOptionsProfitCenter,
    valueOptionsWerk,
  });

  if (!candidates.length) {
    return null;
  }

  try {
    await Promise.all(
      candidates.map((candidate) =>
        createDownstreamStatusUpdateNotification({
          candidate,
          screenGridId,
          createdBy,
          configSchema,
        }),
      ),
    );

    return null;
  } catch (error) {
    return error instanceof Error ? error.message : 'Downstream status update notification failed';
  }
}
